import { useEffect, useMemo, useState } from 'react'

import type { QrPanelState } from '../types'
import { isWaitingStatus } from '../utils'

type UseQrCountdownParams = {
  state: QrPanelState
  expiresAtMs: number | null
}

export const useQrCountdown = ({
  state,
  expiresAtMs
}: UseQrCountdownParams) => {
  const [nowMs, setNowMs] = useState(() => Date.now())

  useEffect(() => {
    if (!state.session || !isWaitingStatus(state.status)) {
      return
    }

    const timer = setInterval(() => setNowMs(Date.now()), 1000)

    return () => clearInterval(timer)
  }, [state.session, state.status])

  const secondsRemaining = useMemo(() => {
    if (!state.session || expiresAtMs === null) {
      return 0
    }

    return Math.max(0, Math.ceil((expiresAtMs - nowMs) / 1000))
  }, [expiresAtMs, nowMs, state.session])

  const progressPercent = state.session
    ? Math.max(
        0,
        Math.min(100, (secondsRemaining / state.session.expires_in) * 100)
      )
    : 0

  return { secondsRemaining, progressPercent }
}
